import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const ConfirmationDeleteBlockModal = ({ open, onClose, onConfirm, blockTitle, blockId }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <Typography variant="h6" component="h2">
          Are you sure you want to delete this block?
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Block Title: {blockTitle}
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Block ID: {blockId}
        </Typography>
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose} sx={{ mr: 2 }}>Cancel</Button>
          <Button onClick={onConfirm} variant="contained" color="error">Delete</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationDeleteBlockModal;